export const contextPlaceholderFunction = () => {
  return Promise.reject(`Context not loaded yet`)
}
